module.exports = __webpack_public_path__ + "img/virtuals.00995d32.png";